import React from "react";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer>
      <p>
        &copy; 2025 Zaffron Build with <i className="bi bi-suit-heart-fill"></i> by
        Abhay Rijal.
      </p>
      <span>
        Powered by <a href="https://react.dev/">REACT</a> and{" "}
        <a href="https://www.netlify.com/">Netlify</a>
      </span>
    </footer>
  );
};

export default Footer;
